import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import FileUploadRepository from '@/repositories/fileUploadRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useFileUploadStore = defineStore({
    id: 'fileUpload',
    state: () => ({}),
    actions: {
        /**
         * アップロード履歴取得処理
         */
        async getUploadFileHistoryPkFromApi(API_URL, queryParam) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const fileUploadRepository = new FileUploadRepository();

            try {
                const response = await fileUploadRepository.getFileUploadActionApi(API_URL, queryParam, idToken);
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * アップロード履歴更新処理
         */
        async updateUploadFileHistoryPkFromApi(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const fileUploadRepository = new FileUploadRepository();

            try {
                const response = await fileUploadRepository.putFileUploadActionApi(API_URL, requestBody, idToken);
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'put', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        //セッションストレージに保存
        //storage: sessionStorage,
    },
});
